module.exports = __webpack_public_path__ + "static/media/discard_disable.6b312d79.svg";